/**
 * Usage:
 *
 * import cancellation from "@/mixins/cancellation";
 *
 * mixins: [cancellation],
 *
 * const { response, cancelled } = await this.http({ url, label: "platforms" });
 * if (cancelled) return;
 *
 * this.abortGroup("report-data");
 *
 * // or for store actions that use '@/libs/http'
 * this.$store.dispatch("action", { component: this._cid, … })
 *
 * See `http` in '@/libs/http' for the result and the cancellation rules, and
 * `useHttp` for the Composition API.
 */

import { http, http_download } from "@/libs/http";
import { randomString } from "@/libs/strings";

export default {
  beforeCreate() {
    // Component ID, to avoid using private attribute this._uid
    // Eg.: DashboardPage-n4hl2wq7
    this._cid = `${this.$options.name}-${randomString(8)}`;
    this.$store.dispatch("cancellation/setup", this._cid);
  },

  beforeUnmount() {
    this.$store.dispatch("cancellation/cancel", this._cid);
  },

  methods: {
    http: async function (request) {
      return await http({ ...request, component: this._cid });
    },
    http_download: async function (request) {
      return await http_download({ ...request, component: this._cid });
    },
    abortGroup(group) {
      this.$store.dispatch("cancellation/abortGroup", {
        component: this._cid,
        group,
      });
    },
  },
};
